
  import {
    TimeSensitivityStatus,
    InspectionResultStatus
  } from '@/types/model/inspection';
  
  export const getStatusColor = (timeSensitivity: TimeSensitivityStatus) => {
    switch (timeSensitivity) {
      case 'past-due': return 'danger';
      case 'due': return 'warning';
      case 'upcoming': return 'success';
      case 'unscheduled': return 'medium';
      default: return 'medium';
    }
  };

  export const getStatusText = (status: InspectionResultStatus) => {
    switch (status) {
      case 'not-started': return 'Not Started';
      case 'in-progress': return 'In Progress';
      case 'completed': return 'Completed';
      case 'approved': return 'Approved';
      case 'disapproved': return 'Disapproved';
      default: return 'Unknown';
    }
  };

  export const getInspectionStatusColor = (status: InspectionResultStatus): string => {
    switch (status) {
      case 'approved': return '#1a7a1a';
      case 'disapproved': return '#c0392b';
      case 'in-progress': return '#c87000';
      case 'completed': return '#2980b9';
      case 'not-started': return '#888888';
      default: return '#888888';
    }
  };

  export const getTimeSensitivityColor = (timeSensitivity: TimeSensitivityStatus): string => {
    switch (timeSensitivity) {
      case 'past-due': return '#c0392b';
      case 'due': return '#e67e22';
      case 'upcoming': return '#1a7a1a';
      case 'unscheduled': return 'var(--ion-color-medium)';
      default: return 'var(--ion-color-medium)';
    }
  };

  export const getTimeSensitivityText = (timeSensitivity: TimeSensitivityStatus): string => {
    switch (timeSensitivity) {
      case 'past-due': return 'Past Due';
      case 'due': return 'Currently Due';
      case 'upcoming': return 'Upcoming';
      case 'unscheduled': return '';
      default: return '';
    }
  };